<template>
  <div class="stpe_one order_list" id="orderlist">
    <div class="service_category">
      <div class="service_category_info" style="padding-bottom: 14px">
        <div class="info_settype jiaju" style="margin-bottom: 10px">
          <div class="type_name"><span class="xing">*</span>商品类目</div>
          <div class="type_content">
            <div
              class="category"
              style="
                height: 70px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
              @click="checkToClass(item)"
              :class="{ isCheck: item.isSelected }"
              v-for="(item, index) in categoryCommodities"
              :key="index"
            >
              <div class="jiaju" style="width: 48px; height: 48px">
                <img :src="item.icon" alt />
              </div>
              <span
                style="display: inline-flex; height: 14px; line-height: 14px"
                >{{ item.name }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="step_one_main" v-if="this.params.goodTypeId">
      <div class="service_category" style="margin-top: 10px">
        <div class="step_title huowu-tit">
          下单步骤
          <span
            ><img
              style="width: 20px; height: 18px; margin-right: 8px"
              src="@/assets/img/notice.png"
              alt=""
            />请注意：只能导入当前已选类目的商品订单</span
          >
        </div>
        <div class="service_category_info steporder">
          <div>
            <span>1</span
            >下单商品需已录入到“我的商品”中，下载“我的商品”如未录入“<i
              @click="$router.push('/user/commodity')"
              >点我去录入</i
            >”
            <el-button class="default" @click="handleExportXls('我的商品')"
              >下载商品</el-button
            >
          </div>
          <div>
            <span>2</span>下载订单信息模板，并填订单信息<el-button
              class="default"
              @click="exportTemplate"
              >模板下载</el-button
            >
          </div>
          <div>
            <span>3</span>上传已填写好的模板
            <el-upload
              class="upload-demo"
              :action="baseApl + '/order/api/order/order_import'"
              :on-change="handleUpload"
              :file-list="fileList"
              :data="updatedData"
              :headers="headers"
            >
              <!-- <el-button size="small" type="primary">点击上传</el-button> -->
              <el-button :loading="loading" class="default">导入数据</el-button>
              <!-- <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div> -->
            </el-upload>
          </div>
          <div>
            <span>4</span>导入成功后，可在“<i
              @click="$router.push({ path: '/user/batch/order' })"
              >批量导入记录</i
            >”中查看结果
          </div>
        </div>
      </div>
    </div>
    <addressConfirm-modal ref="addressConfirmModal"></addressConfirm-modal>
  </div>
</template>

<script>
import addressConfirmModal from "./addressConfirmModal";
import { downFile, getAction } from "@/api/manage";

export default {
  components: {
    addressConfirmModal,
  },
  props: {
    orderType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fileList: [],
      baseApl: process.env.VUE_APP_BASE_API,
      categoryCommodities: [],
      url: {
        exportXlsUrl: "/order/api/order/download_user_goods",
        template: "/order/api/order/get_first_template",
        stream: "/order/api/order/get_first_template_stream",
      },
      updatedData: {},
      params: {},
      loading: false,
      headers: {
        "WEB-TOKEN": Cookies.get("token"),
      },
    };
  },
  // 接收注入的数据
  inject: ["reload"],
  activated() {
    var _this = this;
    // 获取商品类目
    this.$fetch(`/common/api/goods_type/top_class`).then((res) => {
      if (res.code == 0) {
        res.data.map((i) => {
          i.isSelected = false;
          if (i.id == this.$store.state.immediateData.goodsTypeId) {
            i.isSelected = true;
          }
        });
        _this.categoryCommodities = res.data;
      } else {
        this.$message(res.message);
      }
    });
  },

  methods: {
    addressConfirmModal(list) {
      this.$refs.addressConfirmModal.init(list);
    },
    // 文件上传更新状态
    handleUpload(file, fileList) {
      this.loading = true;
      if (file.status == "success") {
        this.loading = false;
        this.addressConfirmModal(fileList[fileList.length - 1].response.data);
      }
      console.log(file);
      console.log(file.status);
      console.log(fileList);
    },
    // 模板下载
    exportTemplate() {
      let params = Object.assign({ orderType: this.orderType });
      getAction(this.url.template, params).then(
        ({ data }) => {
          if (data.code == 0) {
            // window.open(data.data.downloadUrl, "_black");
            let fileName = data.data.originalName
            // if (!fileName || typeof fileName != "string") {
            //   fileName = "导出文件";
            // }
            downFile(this.url.stream, params).then(({ data }) => {
              if (!data) {
                this.$message.warning("文件下载失败");
                return;
              }
              console.log(data);
              // return false
              if (typeof window.navigator.msSaveBlob !== "undefined") {
                window.navigator.msSaveBlob(
                  new Blob([data], { type: "application/vnd.ms-excel" }),
                  fileName
                );
              } else {
                let url = window.URL.createObjectURL(
                  new Blob([data], { type: "application/vnd.ms-excel" })
                );
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); //下载完成移除元素
                window.URL.revokeObjectURL(url); //释放掉blob对象
              }
            });
          }
        }
      );
    },
    // 下载我的商品
    handleExportXls(fileName) {
      if (!fileName || typeof fileName != "string") {
        fileName = "导出文件";
      }
      let params = Object.assign(this.params);
      console.log(params);
      downFile(this.url.exportXlsUrl, params).then(({ data }) => {
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
            new Blob([data], { type: "application/vnd.ms-excel" }),
            fileName + ".xls"
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: "application/vnd.ms-excel" })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    // 选择商品类目
    checkToClass(item) {
      this.params.goodTypeId = item.id;
      this.updatedData.goodTypeId = item.id;
      this.updatedData.goodTypeName = item.name;
      this.updatedData.orderType = this.orderType;
      if (false) {
        this.$alert("更换服务类目会导致已添加的商品丢失，确定切换", "提示", {
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          callback: (action) => {
            if (action == "confirm") {
              this.$router.go(0);
            }
          },
        });
      } else {
        // var orderData = this.$store.state.immediateData;
        // orderData.orderItems.map((i) => {
        //   i.goodsTypeId = null;
        // });
        this.categoryCommodities.map((i) => {
          i.isSelected = false;
        });
        item.isSelected = true;
        // this.$store.state.immediateData.goodsTypeId = item.id;
        // this.getGoodsType();
        // this.getServiceType();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#orderlist {
  .default {
    width: 66px !important;
    height: 26px !important;
    border-color: #dcdfe6;
    color: #5e6066;
    font-size: 12px;
    margin-left: 21px;
  }
}
/deep/.el-upload-list {
  display: none;
}
.service_category {
  margin-top: 0;
  .huowu-tit {
    justify-content: flex-start;

    span {
      color: #f75658;
      font-size: 12px;
      margin-left: 24px;
    }
  }
}
.steporder {
  font-size: 14px;
  color: #2f3133;
  padding-top: 20px !important;
  & > div {
    margin-top: 32px;
    display: flex;
    align-items: center;
    position: relative;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      &::after {
        display: none;
      }
    }

    &::after {
      content: "";
      position: absolute;
      border-left: 1px dashed #3455d3;
      left: 13px;
      top: 30px;
      height: 28px;
    }
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      width: 28px;
      height: 28px;
      border: 1px solid #3455d3;
      margin-right: 18px;
      color: #3455d3;
    }
  }
  i {
    font-style: normal;
    color: #3455d3;
    cursor: pointer;
  }
}
</style>
